import React from 'react';
import type { ITraceableTrader } from '@wix/app-market-services';
import { Box, Text, TextButton } from '@wix/design-system';
import { useEssentials } from '../../contexts/essentials-context';

export function TraceableTraderPopoverContent({
  phone,
  email,
  address,
  name,
}: ITraceableTrader) {
  const { t } = useEssentials();
  return (
    <Box
      dataHook="traceable-trader-disclaimer-content"
      width="100%"
      direction="vertical"
    >
      <Text size="tiny" lineHeight="tiny">
        {t('app-page.traceable-trader.popover-sub-title')}
      </Text>
      <Box direction="vertical" marginTop="18px">
        <PopOverField
          name={t('app-page.traceable-trader.popover-name')}
          value={name}
        />
        <PopOverField
          name={t('app-page.traceable-trader.popover-phone')}
          value={phone}
        />
        <PopOverField
          name={t('app-page.traceable-trader.popover-email')}
          value={email}
          href={`mailto:${email}`}
        />
        <PopOverField
          name={t('app-page.traceable-trader.popover-address')}
          value={address}
        />
      </Box>
    </Box>
  );
}

function PopOverField({
  name,
  value,
  href,
}: {
  name: string;
  value: string;
  href?: string;
}) {
  return (
    <Box direction="horizontal" lineHeight="15px">
      <Text size="tiny" secondary weight="thin" suffix=" ">
        {name}:
      </Text>
      <Box marginLeft="SP1">
        {href ? (
          <TextButton as="a" size="tiny" href={href} target="_blank">
            {value}
          </TextButton>
        ) : (
          <Text size="tiny" secondary weight="thin">
            {value}
          </Text>
        )}
      </Box>
    </Box>
  );
}
